'use client'
import { ChatContainer } from './components/chat-container'
import { ThemeProvider } from './lib/themeContext'
import { themes } from './lib/themes'

export const runtime = 'nodejs'

function getSubdomain() {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : ''
  const subdomain = hostname.split('.')[0] // Extract subdomain
  return subdomain
}

export default function Page() {
  const subdomain = getSubdomain()
  const theme = themes[subdomain as keyof typeof themes] || themes.titan // Default to Titan theme if subdomain is not found

  return (
    <ThemeProvider theme={{ ...theme }}>
      <ChatContainer />
    </ThemeProvider>
  )
}
